import React, { useState, useEffect } from "react";
import { AmenityLink, AmenityNoLink } from "./StyledComponents";
import Star2 from "../../../assets/SVGComponents/Star2";
import { findLinkById } from "../../../assets/store/findLink";

function Amenity(props) {
    const {
        color,
        linkColor,
        hoverColor,
        dataAttributes,
        amenity,
        links,
        textColor,
        clickindex,
        divId,
        rowId,
    } = props;

    const { url, open_link_in_new_tab, url_id, text } = amenity;
    const [amenityLink, setAmenityLink] = useState(null);
    const [linkTarget, setLinkTarget] = useState("_self");

    function handleClick() {
        if (amenityLink) {
            window.open(amenityLink, linkTarget);
        };
    };

    useEffect(() => {
        const selectedClientLink = findLinkById({ links, linkType: url_id });

        if (url && url !== "") {
            setAmenityLink(url);
            setLinkTarget(open_link_in_new_tab ? "_blank" : "_self");
        } else {
            setAmenityLink(selectedClientLink?.link);
            setLinkTarget(
                selectedClientLink
                    ? selectedClientLink.open_link_in_new_tab
                        ? "_blank"
                        : "_self"
                    : open_link_in_new_tab
                    ? "_blank"
                    : "_self"
            );
        }
    }, [url, url_id]);

    const gaAttributes = {
        "data-clickurl": amenityLink,
        "data-clickindex": clickindex,
    };

    return (
        <>
            {amenityLink ? (
                <AmenityLink
                    {...dataAttributes}
                    {...gaAttributes}
                    className="FODAmenitiesLink FODV5GAAmenitiesSectionClickEvent"
                    onClick={handleClick}
                    linkColor={linkColor}
                    hoverColor={hoverColor}
                >
                    <Star2
                        fill={color ?? "#e82738"}
                        svgIconSize={15}
                        styles={{ minWidth: 15, minHeight: 15 }}
                    />
                    {text}
                </AmenityLink>
            ) : (
                <AmenityNoLink
                    className="FODTextAmenity"
                    data-clickindex={clickindex}
                    textColor={textColor}
                >
                    <Star2
                        fill={color ?? "#e82738"}
                        svgIconSize={15}
                        styles={{ minWidth: 15, minHeight: 15 }}
                    />
                    {text}
                </AmenityNoLink>
            )}
        </>
    );
}

export default Amenity;
